import { useState, useContext } from 'react';
import axios from 'axios';
import { useFormContext } from 'react-hook-form';
// Import contexts
import { FormDataContext } from 'globalState/FormDataContext';

const useSubmitForm = (setFormSubmitStatus) => {
  const [formDataState] = useContext(FormDataContext); // Get the state/dispatch of form data from FormDataContext
  const { trigger } = useFormContext(); // Get useForm methods
  const [isFetching, setIsFetching] = useState(false);
  const [APIErrorMessage, setAPIErrorMessage] = useState(null);

  // Destructure values from our formDataState (get all users values)
  const {
    EnquiryType,
    MayorEnquiry,
    StrategyEnquiry,
    OtherEnquiry,
    emailAddress,
    ContactPhone,
    firstName,
    lastName,
    Enquiry,
    EventName,
    EventStartTime,
    EventDuration,
    DateOfEvent,
    Address,
    AddressPostcode,
    EventDescription,
    Company,
    InformationRequested,
    ExtraDetails,
    AllegationDetails,
    ExtraAllegationDetails,
    JobsEnquiry,
    PhotoName,
    PhotoBase64,
  } = formDataState.formData;

  // console.log(formDataState.formData);

  // Map all destructured vals above to an object we will send to API
  let dataToSend = {};
  let file = [];
  let email = 3; // default email to send to if not other conditions are met (general inbox)
  // eslint-disable-next-line
  if (EnquiryType === 'general') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      Enquiry,
    };
    // eslint-disable-next-line
  } else if (EnquiryType === 'strategy') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Strategy Enquiry': StrategyEnquiry,
      Enquiry,
    };
  } else if (
    // eslint-disable-next-line
    EnquiryType === 'mayor' &&
    MayorEnquiry === 'An enquiry for the Mayor’s office'
  ) {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Mayor Enquiry': MayorEnquiry,
      Enquiry,
    };
    // eslint-disable-next-line
  } else if (EnquiryType === 'mayor' && MayorEnquiry === 'Invite the Mayor to an event') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Mayor Enquiry': MayorEnquiry,
      'Event Name': EventName,
      'Date of event': DateOfEvent,
      'Event Start Time': EventStartTime,
      'Event Duration': EventDuration,
      Address,
      Postcode: AddressPostcode,
      'Event Description': EventDescription,
      Company,
    };
    file = [{ name: PhotoName, content: PhotoBase64 }];
    email = 11;
    // eslint-disable-next-line
  } else if (EnquiryType === 'other' && OtherEnquiry === 'Freedom of information request') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Other Enquiry': OtherEnquiry,
      'Information Requested': InformationRequested,
      'Extra Details': ExtraDetails,
    };
    email = 10;
    // eslint-disable-next-line
  } else if (EnquiryType === 'other' && OtherEnquiry === 'Whistleblowing and fraud') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Other Enquiry': OtherEnquiry,
      'Allegation Details': AllegationDetails,
      'Extra Allegation Details': ExtraAllegationDetails,
    };
    email = 17;
    // eslint-disable-next-line
  } else if (EnquiryType === 'other' && OtherEnquiry === 'Jobs at the WMCA') {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Other Enquiry': OtherEnquiry,
      'Jobs Enquiry': JobsEnquiry,
    };
  } else {
    dataToSend = {
      firstName,
      lastName,
      emailAddress,
      'Phone Number': ContactPhone,
      'Enquiry Type': EnquiryType,
      'Strategy Enquiry': StrategyEnquiry,
      'Other Enquiry': OtherEnquiry,
      'Jobs Enquiry': JobsEnquiry,
      Enquiry,
      'Allegation Details': AllegationDetails,
      'Extra Allegation Details': ExtraAllegationDetails,
      'Information Requested': InformationRequested,
      'Extra Details': ExtraDetails,
      'Event Name': EventName,
      'Date Of Event': DateOfEvent,
      'Event Start Time': EventStartTime,
      'Event Duration': EventDuration,
      Address,
      Postcode: AddressPostcode,
      'Event Description': EventDescription,
      Company,
    };
    email = 3;
  }

  // axios.interceptors.request.use((request) => {
  //   console.log('Starting Request', JSON.stringify(request, null, 2));
  //   return request;
  // });

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission method
    // Validation
    const result = await trigger();
    // if no errors
    if (result) {
      // Start submitting API
      setIsFetching(true); // Set this so we can put loading state on button

      // Go hit the API with the data
      axios({
        method: 'post',
        url: `${process.env.REACT_APP_API_HOST}`,
        data: JSON.stringify({
          to: email,
          body: JSON.stringify(dataToSend),
          from: `donotreply@wmca.org.uk`,
          subject: `WMCA Contact Form: ${EnquiryType}`,
          files: file,
          displayName: `${firstName} ${lastName}`,
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          // If the response is successful(200: OK) or error with validation message(400)
          if (response.status === 200 || response.status === 400) {
            const payload = response.config.data;

            // Log event to analytics/tag manager
            window.dataLayer.push({
              event: 'formAbandonment',
              eventCategory: 'wmca-contact-us',
              eventAction: 'form submitted: success',
              eventLabel: 'success',
            });
            setIsFetching(false); // set to false as we are done fetching now
            if (payload.Message) {
              setAPIErrorMessage(payload.Message);
            } else {
              setFormSubmitStatus(true); // Set form status to success
              window.scrollTo(0, 0); // Scroll to top of page
              // set success page
            }
            return true;
          }
          throw new Error(response.statusText, response.Message); // Else throw error and go to our catch below
        })

        // If formsubmission errors
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error({ error });
          let errMsg;

          if (error.text) {
            error.text().then((errorMessage) => {
              errMsg = errorMessage;
            });
          } else {
            errMsg = error;
          }

          // Log event to analytics/tag manager
          window.dataLayer.push({
            event: 'formAbandonment',
            eventCategory: 'wmca-contact-us',
            eventAction: 'form submitted: error',
            eventLabel: errMsg,
          });
          setIsFetching(false); // set to false as we are done fetching now
          setFormSubmitStatus(false); // Set form status to error
          window.scrollTo(0, 0); // Scroll to top of page
          // set error message
        });
    }
  };

  // Return handleSubmit and isFetching so it can be used by form
  return {
    handleSubmit,
    isFetching,
    APIErrorMessage,
  };
};

export default useSubmitForm;
